module.exports = __webpack_public_path__ + "img/1289105780.366c431e.jpg";